import React, {Component} from "react";
import BilateralContractView from "./BilateralContractView";
import {BilateralContractService} from "../../../service/bilateral/contract/BilateralContractService";
import {Button} from "primereact/button";
import {BILATERAL_CONTRACT_ROUTE, EDIT_BILATERAL_CONTRACT_ROUTE} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";

export default class BilateralContractContainer extends Component {
    constructor(props) {
        super(props)
        this.bilateralContractService = new BilateralContractService();
        this.state = {
            isLoading: true,
            dataBilateralContract:[]
        };

        this.loading = this.loading.bind(this);
        this.getDataContracts = this.getDataContracts.bind(this);
        this.bilateralContractActionTemplate = this.bilateralContractActionTemplate.bind(this);
        this.redirectEditBilateralContract = this.redirectEditBilateralContract.bind(this);
    };

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option || false,
            });
        }
    }
    /**
     * Función que consume el BilateralContract y obtiene la información
     * sobre los contratos.
     * @returns {Promise<void>}
     */
    getDataContracts() {
        this.loading(true);
        return this.bilateralContractService.getBilateralContract()
            .then(res => {
               if (this.validResponse(res)){
                   this.setState({
                       dataBilateralContract: res.data,
                   })
               }
                this.loading(false);
            })
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({sticky: true, severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.getDataContracts();
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que realiza el template de la última columna de la tabla, donde se
     * muestra un botón para editar el elemento.
     * @param rowData Valor del renglón
     * @param column Valor de la columna
     * @returns {html} Template del botón editar.
     */
    bilateralContractActionTemplate(rowData, column) {
        return (
            <Button type="button"
                    label="Editar"
                    style={{marginRight: '.3em'}}
                    onClick={() => this.redirectEditBilateralContract(rowData)}/>
        );
    }

    /**
     * Función que redirecciona a la pantalla de editar el contrato seleccionado
     * Se envía el contrato y la ruta a la que tiene que que regresar.
     * @param rowData Elemento que trae la información del objeto a editar.
     */
    redirectEditBilateralContract(rowData) {
        this.props.history.push({
            pathname: EDIT_BILATERAL_CONTRACT_ROUTE,
            state: {
                returnPath: BILATERAL_CONTRACT_ROUTE,
                contractSelected: rowData,
            },
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return <BilateralContractView
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            dataBilateralContract = {this.state.dataBilateralContract}
            bilateralContractActionTemplate = {this.bilateralContractActionTemplate}
            getDataContracts={this.getDataContracts}
        />
    }
}

BilateralContractContainer.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
};